import React from 'react';
export { default } from './IllustrationButton';
export * from './IllustrationButton';
import IllustrationButton from './IllustrationButton';
import NewHistoricalChart from './NewHistoricalChart';
export const NewHistoricalChartButton = (props) => (React.createElement(IllustrationButton, { illustration: React.createElement(NewHistoricalChart, null), ...props }));
export const ILLUSTRATION_BUTTONS = {
    NewHistoricalChart: NewHistoricalChartButton,
};
